import React from 'react';
import { Box, Fields } from 'modules/af_cm_ui_kit';
import fields, { FIELDS } from 'modules/cm/fields/types';

import { SectionProps } from './types';
import { Field } from 'formik';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';

const LoanSection: React.FC<SectionProps> = ({ resources }) => {
  return (
    <Box title="Loan">
      <Field
        component={Fields.Select}
        title={fields[FIELDS.PURPOSE_OF_THE_LOAN].label}
        name={fields[FIELDS.PURPOSE_OF_THE_LOAN].name}
        options={resources.purposesOfTheLoan}
      />

      <Field
        component={Fields.Select}
        title={fields[FIELDS.PEPPER_PURPOSE_OF_THE_LOAN].label}
        name={fields[FIELDS.PEPPER_PURPOSE_OF_THE_LOAN].name}
        options={resources.pepperPurposesOfTheLoan}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.GROSS_LOAN].label}
        name={fields[FIELDS.GROSS_LOAN].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.LOAN_AMOUNT_PURCHASE].label}
        name={fields[FIELDS.LOAN_AMOUNT_PURCHASE].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.LOAN_AMOUNT_REMORTGAGE].label}
        name={fields[FIELDS.LOAN_AMOUNT_REMORTGAGE].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.LOAN_DEBT_CONSOLIDATION].label}
        name={fields[FIELDS.LOAN_DEBT_CONSOLIDATION].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.LOAN_HOME_IMPROVEMENTS].label}
        name={fields[FIELDS.LOAN_HOME_IMPROVEMENTS].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.LOAN_DISCRETIONARY_SPEND].label}
        name={fields[FIELDS.LOAN_DISCRETIONARY_SPEND].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.NET_LOAN].label}
        name={fields[FIELDS.NET_LOAN].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.ESTIMATED_PROPERTY_VALUE].label}
        name={fields[FIELDS.ESTIMATED_PROPERTY_VALUE].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.PROPERTY_PURCHASE_PRICE].label}
        name={fields[FIELDS.PROPERTY_PURCHASE_PRICE].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.ACTUAL_PROPERTY_VALUE].label}
        name={fields[FIELDS.ACTUAL_PROPERTY_VALUE].name}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.LTV].label}
        name={fields[FIELDS.LTV].name}
        variant={VARIANTS_TYPES.PERCENTAGE}
      />

      <Field
        component={Fields.Select}
        title={fields[FIELDS.VALUATION_FEE_PAYMENT].label}
        name={fields[FIELDS.VALUATION_FEE_PAYMENT].name}
        options={resources.valuationFees}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.CURRENT_MORTGAGE_PROVIDER].label}
        name={fields[FIELDS.CURRENT_MORTGAGE_PROVIDER].name}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.POSTCODE].label}
        name={fields[FIELDS.POSTCODE].name}
        variant={VARIANTS_TYPES.POSTCODE}
      />
    </Box>
  );
};

export default LoanSection;
